<template>
<v-row>
  <div class="col-md-12">
    <v-card class="elevation-2" color="#F5F5F5">
    <!-- <v-card-subtitle>
      <span class="title text--black font-weight-black font-weight-bold">
        {{`[ ${model.folio} ]`}}
      </span>
    </v-card-subtitle> -->
    <v-card-text>
        <v-row dense>
            <v-col v-if="model.rfc" cols="12" sm="12" md="6">
                <label class="font-weight-bold subtitle-1 text--primary">RFC: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.rfc}}
                </p>
            </v-col>
            <v-col v-if="model.nombre" cols="12" sm="12" md="6">
                <label class="font-weight-bold subtitle-1 text--primary">Nombre: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.nombre}}
                </p>
            </v-col>
            <v-col v-if="model.factura" cols="12" sm="12" md="6">
              <div>
                <label class="font-weight-bold subtitle-1 text--primary">Folio fiscal: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.factura.descripcion.folio_fiscal}}
                </p>
              </div>
            </v-col>
            <v-col v-if="model.caracteristicas" cols="12" sm="12" md="6">
                <label class="font-weight-bold subtitle-1 text--primary">Contrato: </label>
                <p class="font-weight-bold text--secondary">
                    {{model.caracteristicas.contrato}}
                </p>
            </v-col>
            <v-col v-if="countDocumentosCargados(documentos) > 1" cols="12" sm="12" md="6">
              <v-btn
              @click="downloadAllFiles()"
              color="success"
              :loading="processing"
              :disabled="processing"
              block>
                <v-icon left>mdi-download</v-icon>
                Descargar todos los documentos [{{ countDocumentosCargados(documentos) }}]
              </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
  </v-card>
  </div>
  <div class="col-md-12" v-if="dialog2">
    <v-card loading=true
    tile elevation="0">
    <v-toolbar v-if="documento" dense dark color="blue darken-2">
                <v-toolbar-title> <h3 class="ma-1">Previsualización: {{ documento.nombre }}</h3></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog2()"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-toolbar>
    <v-card-text>
      <iframe
        class="iframe-custom"
        :src=this.pdfPage
        frameborder="0"
        scrolling="no"
        allowfullscreen>
      </iframe>
    </v-card-text>
  </v-card>
  </div>
  <div class="col-md-6" v-if="documentos.length > 0 && !this.pdfPage">
    <v-card class="elevation-2">
    <v-card-subtitle>
      <span class="title text--black font-weight-black font-weight-bold">
        Documentos digitales
      </span>
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text class="entry-scrollarea">
        <v-btn
      v-for="item in documentos"
      :key="item.title"
      @click="show(item)"
      :class="setClass(item)"
      block> {{ item.nombre.substring(0, 34) }} </v-btn>
    </v-card-text>
  </v-card>
</div>
<div class="col-md-6" v-if="documentos.length > 0 && !this.pdfPage">
  <p class="text-h5 text-center" v-if="!documento">Por favor seleccione un documento de la lista</p>
  <v-card v-if="documento" class="elevation-2">
    <v-card-title>
      {{ documento.nombre }}
    </v-card-title>
    <v-card-subtitle>
      <span class="title text--black font-weight-black font-weight-bold">
        Obligatorio: <span v-if="documento" v-text="documento.obligatorio"></span>
      </span>
    </v-card-subtitle>
    <v-card-text>
      <p v-if="documento.descripcion">{{ documento.descripcion }}</p>
        <v-row dense>
            <v-col  cols="12" sm="12" md="12">
              <v-btn
              v-if="ValidateOnlyPermiss('empresa.downloadone-documentos') && checkActivo(documento)"
              @click="downloadFile()"
              :loading="loadingBtn"
              block
              elevation="2"
              ><v-icon left>mdi-download</v-icon>
              Descargar documento
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn
              v-if="ValidateOnlyPermiss('empresa.showone-documentos') && checkActivo(documento)"
              @click="mostrarDoc(documento)"
              :loading="this.btnMostrarDoc"
              block
              elevation="2"
              ><v-icon left>mdi-eye</v-icon>
              Ver Documento
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn
              v-if="ValidateOnlyPermiss('empresa.delete-documentos') && checkEliminar(documento) && !esLectura"
              @click="eliminarDoc(documento)"
              block
              elevation="2"
              ><v-icon left>mdi-delete</v-icon>
              Eliminar documento
              </v-btn>
            </v-col>
            <v-col v-if="! checkActivo(documento) && ValidateOnlyPermiss('empresa.saveone-documentos') && !esLectura" cols="12" sm="12" md="12">
                <v-file-input
                  v-model="file"
                  type="file"
                  accept="application/pdf"
                  ref="fileSelector"
                  placeholder="Seleccione archivo PDF"
                >
                </v-file-input>
                <v-btn
                  v-on:click="subirDoc(documento)"
                  :disabled="!this.file"
                  block
                  :loading="loadingBtn"
                ><v-icon left>mdi-upload</v-icon>
                  Subir documento
                </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
  </v-card>

  <v-container v-if="documento">
    <v-row>
      <v-switch v-if="ValidateOnlyPermiss('empresa.activate-documentos') && !esLectura"
      v-model="switch1"
      :label="`Documento ${this.switch1 ? 'validado':'por validar'}`"
      v-on:click="validarDoc(documento)"
      ></v-switch>
    </v-row>
  </v-container>
</div>
<v-progress-linear
    :active="progressbar"
    :indeterminate="true"
    absolute
    bottom
    color="blue darken-2 accent-4">
  </v-progress-linear>
</v-row>
</template>

<style lang="scss" scoped>
.entry-scrollarea{
    height: 350px;
    overflow-y: scroll;
}
.iframe-custom {
  width: 100%;
  height: 70vh;
}
</style>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import axios from 'axios'
import { Permission } from '@/mixins/permissionMain'
export default {
  name: 'checklist',
  mixins: [Permission],
  props: {
    model: {
      type: Object,
      default: null
    },
    esLectura: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      default: 'RM'
    }
  },
  data: () => ({
    item: [],
    items: [],
    documento: null,
    documentos: [],
    file: null,
    switch1: false,
    progressbar: false,
    loadingBtn: false,
    financieros: ['VOUCHER', 'POL-EJER', 'POL-PAGADO'],
    loadingBtnDocs: true,
    dialog2: false,
    pdfPage: null,
    btnMostrarDoc: false,
    processing: false
  }),
  created () {
    this.loadDocumentos()
  },
  methods: {
    ...mapActions(['getUrExportDataServerAction']),
    ...mapMutations(['RELOAD_DATA_OBJECT']),
    checkActivo (documento) {
      if (documento.documento) {
        if (documento.documento.activo === 'si') {
          return true
        }
        return false
      }
      return false
    },
    countDocumentosCargados (documentos) {
      let counter = 0
      if (documentos[0]) {
        documentos.forEach(d => {
          if (d.documento) {
            if (d.documento.activo === 'si') {
              counter++
            }
          }
        })
      }
      return counter
    },
    checkEliminar (documento) {
      if (documento.documento) {
        if (documento.documento.activo === 'si') {
          if (documento.documento.validado === 'si') {
            return false
          }
          return true
        }
        return false
      }
      return false
    },
    setClass (documento) {
      if (documento.documento) {
        if (documento.documento.activo === 'no') return 'mb-2'
        if (documento.documento.validado === 'si') return 'mb-2 success'
        if (documento.documento.validado === 'no') return 'mb-2 amber'
      }
      return 'mb-2'
    },
    show: function (item) {
      this.file = null
      this.documento = item
      if (this.documento.documento) {
        this.switch1 = (this.documento.documento.validado === 'si')
      } else {
        this.switch1 = false
      }
    },
    subirDoc: function (doc) {
      this.$swal.fire({
        title: '¿ Deseas subir este documento ?',
        text: 'Este documento se adjuntara a este seguimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Subir!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingBtn = true
          this.progressbar = true
          const formData = new FormData()
          formData.append('file', this.file)
          formData.append('documento', JSON.stringify(this.documento))
          formData.append('model', JSON.stringify(this.model))
          formData.append('eslectura', JSON.stringify(this.esLectura))
          formData.append('tipo', JSON.stringify(this.tipo))
          const token = this.$cookies.get('token')
          axios.post('/empresa/documentos/saveone', formData, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
            this.progressbar = false
            this.loadingBtn = false
            if (response.data.code === 204) {
              this.$swal.fire(
                'Hubo un problema al subir el documento',
                response.data.message,
                'warning'
              )
              return
            }
            this.$swal.fire(
              'Archivo guardado!',
              'Tu documento se guardo con exito.',
              'success'
            )
            // validar si son documentos de rf (falta estandar para el mismo objeto)
            this.documentos = response.data
            // this.RELOAD_DATA_OBJECT(response.data)
          }).catch(error => {
            this.progressbar = false
            this.$swal.fire(
              'Hubo un problema al subir el documento',
              error,
              'error'
            )
          })
        }
      })
    },
    validarDoc: function (doc) {
      this.$swal.fire({
        title: 'Revision',
        text: `¿ Deseas ${this.switch1 ? 'validar' : 'remover la validacion'} ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          this.progressbar = true
          const formData = new FormData()
          formData.append('validado', this.switch1)
          formData.append('documento', JSON.stringify(this.documento))
          formData.append('model', JSON.stringify(this.model))
          const token = this.$cookies.get('token')
          axios.post('/empresa/documentos/activate', formData, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
            this.progressbar = false
            this.$swal.fire(
              'Archivo validado!',
              'Tu documento se valido con exito.',
              'success'
            )
            // validar si son documentos de rf (falta estandar para el mismo objeto)
            if (this.financieros.includes(this.documento.prefijo)) {
              const result = response.data.documentosrf.find(d => d.id === doc.id)
              if (result) {
                doc.documento = result.documento
              }
            } else {
              const result = response.data.documentos.find(d => d.id === doc.id)
              if (result) {
                doc.documento = result.documento
              }
            }
          }).catch(error => {
            this.progressbar = false
            this.$swal.fire(
              'Hubo un problema al validar el documento',
              error,
              'error'
            )
          })
        } else {
          if (this.switch1) {
            this.switch1 = false
          } else {
            this.switch1 = true
          }
        }
      })
    },
    downloadFile: function (event) {
      this.progressbar = true
      this.loadingBtn = true
      const formData = new FormData()
      formData.append('documento', JSON.stringify(this.documento))
      formData.append('model', JSON.stringify(this.model))
      const token = this.$cookies.get('token')
      axios.post('/empresa/documentos/downloadone', formData, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }).then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        const doc = this.documento.documento
        fileLink.setAttribute('download', `${doc.nombre}${doc.extension}`)
        document.body.appendChild(fileLink)
        fileLink.click()
        this.progressbar = false
        this.loadingBtn = false
      }).catch(error => {
        this.progressbar = false
        this.loadingBtn = false
        this.$swal.fire(
          'Hubo un problema al descargar el documento',
          error,
          'error'
        )
      })
    },
    downloadAllFiles: async function (event) {
      this.processing = true
      const router = this.get_urls['seguimiento.documentos-solicitud'].replace('{folio}', this.model.folio)
      await this.getUrExportDataServerAction({ url: router, data: this.model })
      this.processing = false
    },
    eliminarDoc: function (doc) {
      this.$swal.fire({
        title: 'Eliminar',
        text: `¿ Deseas eliminar el documento "${doc.nombre}" ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          this.progressbar = true
          const formData = new FormData()
          formData.append('activo', 'no')
          formData.append('documento', JSON.stringify(this.documento))
          formData.append('model', JSON.stringify(this.model))
          formData.append('eslectura', JSON.stringify(this.esLectura))
          formData.append('tipo', JSON.stringify(this.tipo))
          const token = this.$cookies.get('token')
          axios.post('/empresa/documentos/delete', formData, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
            this.progressbar = false
            this.$swal.fire(
              'Archivo Eliminado!',
              'Tu documento se elimino.',
              'success'
            )
            // validar si son documentos de rf (falta estandar para el mismo objeto)
            this.documentos = response.data
          }).catch(error => {
            this.progressbar = false
            this.$swal.fire(
              'Hubo un problema al eliminar el documento',
              error,
              'error'
            )
          })
        }
      })
    },
    mostrarDoc: function (doc) {
      this.progressbar = true
      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const formData = new FormData()
      formData.append('documento', JSON.stringify(this.documento))
      formData.append('model', JSON.stringify(this.model))
      axios.post('/empresa/documentos/showone', formData, { headers: header }).then((response) => {
        let blob = null
        if (this.documento.documento.extension === '.pdf') {
          // decode base64 string, remove space for IE compatibility
          var binary = atob(response.data.pdf.replace(/\s/g, ''))
          var len = binary.length
          var buffer = new ArrayBuffer(len)
          var view = new Uint8Array(buffer)
          for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i)
          }
          blob = new Blob([view], { type: 'application/pdf' })
        }
        if (this.documento.documento.extension === '.xml') {
          blob = new Blob([atob(response.data.pdf)], { type: 'text/plain' })
        }
        this.pdfPage = URL.createObjectURL(blob)
        this.progressbar = false
        this.dialog2 = true
      }).catch((error) => {
        this.progressbar = false
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    },
    closeDialog2: function () {
      this.dialog2 = false
      this.pdfPage = null
    },
    ValidateOnlyPermiss (permiso) {
      const permisos = JSON.parse(localStorage.getItem('permisos'))
      return this.ReadOnlyPermiso(permisos, permiso)
    },
    loadDocumentos () {
      this.progressbar = true
      const formData = new FormData()
      formData.append('model', JSON.stringify(this.model))
      formData.append('eslectura', JSON.stringify(this.esLectura))
      formData.append('tipo', JSON.stringify(this.model.tipo))
      const token = this.$cookies.get('token')
      axios.post('/empresa/documentos/getdocumentos', formData, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.loadingBtnDocs = false
        this.progressbar = false
        this.loadingBtn = false
        if (response.data.code === 204) {
          this.$swal.fire(
            'Hubo un problema al subir el documento',
            response.data.message,
            'warning'
          )
          return
        }
        this.documentos = response.data
      }).catch(error => {
        this.loadingBtnDocs = false
        this.progressbar = false
        this.$swal.fire(
          'Hubo un problema al cargar los documentos',
          error,
          'error'
        )
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain']),
    ...mapState(['dialogMain'])
  },
  watch: {}
}
</script>
